import { Iframe } from './iframe'

export * from './iframe'

export default Iframe